export default __webpack_public_path__ + "static/media/5、首页电解质水.144e38ec.jpg";